var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MasterDetail',{ref:"table",attrs:{"cols":_vm.cols,"contextOptions":_vm.options,"customResource":_vm.customResource,"formTitle":_vm.formTitle,"opts":_vm.opts},on:{"onOpenFormDialog":_vm.onOpenFormDialog}})}
var staticRenderFns = []

export { render, staticRenderFns }